import React, { useState } from "react";
import moment from "moment";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../../../Utils/renderField/renderReadField";
import { CargasTancadaDetalle } from "./CargasTancadaDetalle";

const rightArrowIcon = require("assets/img/icons/right-arrow.png");

const COLUMNAS = 6;

const formatFechaHora = (fecha) =>
    fecha ? moment(fecha).format("DD/MM/YYYY HH:mm") : "";

// Una fila por tancada, en orden cronológico. El turno es el mismo para todas y
// se muestra arriba, así que aquí lo que cambia de una fila a otra es la orden
// de producción a la que pertenece la tancada
export const TancadasTurnoTable = ({ tancadas }) => {
    const [filasAbiertas, setFilasAbiertas] = useState([]);

    const AlternarFila = (id) => {
        setFilasAbiertas((previas) =>
            previas.includes(id)
                ? previas.filter((fila) => fila !== id)
                : previas.concat(id),
        );
    };

    return (
        <div className="new-table-wrapper mb-4">
            <table>
                <thead>
                    <tr>
                        <th>Tancada</th>
                        <th>Fecha y hora</th>
                        <th>Orden de producción</th>
                        <th>Cargas</th>
                        <th>Kg húmedos</th>
                        <th>Kg secos</th>
                    </tr>
                </thead>
                <tbody>
                    {tancadas.length === 0 && (
                        <tr>
                            <td colSpan={COLUMNAS} className="text-center">
                                No hay tancadas registradas en el turno
                            </td>
                        </tr>
                    )}

                    {tancadas.map((tancada) => (
                        <React.Fragment key={tancada.id}>
                            <tr
                                className={`tancadas-turno__fila-tancada ${
                                    filasAbiertas.includes(tancada.id)
                                        ? "expanded"
                                        : ""
                                }`}
                                onClick={() => AlternarFila(tancada.id)}
                            >
                                <td className="text-nowrap">
                                    <div className="d-flex align-items-center gap-1rem">
                                        <img
                                            src={rightArrowIcon}
                                            alt="Expandir"
                                            className="action_img expand-icon"
                                            style={{
                                                width: "14px",
                                                height: "14px",
                                            }}
                                        />
                                        <span>
                                            {tancada.numero}
                                        </span>
                                        {tancada.cargas_sin_drc > 0 && (
                                            <span
                                                className="tancadas-turno__badge-sin-drc"
                                                title="Tiene cargas sin DRC: no suman kg secos"
                                            >
                                                Sin DRC
                                            </span>
                                        )}
                                    </div>
                                </td>

                                <td className="text-center text-nowrap">
                                    {formatFechaHora(tancada.fecha)}
                                </td>

                                <td className="text-nowrap">
                                    <div className="d-flex flex-column">
                                        <span>{tancada.orden.evs_numero}</span>
                                        <span className="tancadas-turno__dato-secundario">
                                            {tancada.orden.producto} ·{" "}
                                            {tancada.orden.estado_display}
                                        </span>
                                    </div>
                                </td>

                                <td className="text-center">
                                    <RenderNumber
                                        value={tancada.cargas.length}
                                        decimalScale={0}
                                    />
                                </td>
                                <td className="text-right text-nowrap">
                                    <RenderKilogramo
                                        value={tancada.kg_humedos}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-right text-nowrap">
                                    <RenderKilogramo
                                        value={tancada.kg_secos}
                                        decimalScale={2}
                                    />
                                </td>
                            </tr>

                            {filasAbiertas.includes(tancada.id) && (
                                <tr className="tancadas-turno__fila-cargas">
                                    <td colSpan={COLUMNAS}>
                                        <CargasTancadaDetalle
                                            cargas={tancada.cargas}
                                        />
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
